import React from "react";
import "../../css/main.scss";

function CommentBox(props) {
  return <div className="CommentBox" style={props.draft && {background:"#f9f9f9"}}>{props.children}</div>;
}


export default CommentBox;
